export const CAMPOS_DADOS = [
  "ativo",
  "razaosocial",
  "fantasia",
  "cnpj",
  "inscricaoestadual",
  "endereco",
  "numero",
  "complemento",
  "bairro",
  "cidade",
  "uf",
  "cep",
  "telefone",
  "filialretira_id",
];

export const CAMPOS_EDITAVEIS = [
  "ordemexibicao",
  "visivel_site",
  "url_maps",
  "img",
  "filialdestino_id",
  "centrocusto_id",
  "localestoque_id",
];

export const lerFiliaisRetira = (filiaisRetiraIds) =>
  String(filiaisRetiraIds || "")
    .split(",")
    .map((id) => id.trim())
    .filter((id, indice, lista) => id !== "" && lista.indexOf(id) === indice);

export const habilitarRetira = (lista, id) => {
  const filialId = String(id);
  return lista.indexOf(filialId) >= 0 ? [...lista] : [...lista, filialId];
};

export const removerRetira = (lista, id) => lista.filter((filialId) => filialId !== String(id));

export const moverRetira = (lista, indice, direcao) => {
  const destino = indice + direcao;

  if (indice < 0 || indice >= lista.length || destino < 0 || destino >= lista.length) {
    return [...lista];
  }

  const resultado = [...lista];
  [resultado[indice], resultado[destino]] = [resultado[destino], resultado[indice]];
  return resultado;
};

export const montarPayloadFilial = ({
  filial,
  criando,
  filiaisRetira,
  novoApiToken,
  removerApiToken,
}) => {
  const campos = criando
    ? ["id", ...CAMPOS_DADOS, ...CAMPOS_EDITAVEIS]
    : [...CAMPOS_DADOS, ...CAMPOS_EDITAVEIS];

  const payload = campos.reduce((acc, campo) => ({ ...acc, [campo]: filial[campo] }), {
    filiaisretiras_ids: [...(filiaisRetira || [])],
  });

  const tokenInformado = String(novoApiToken || "").trim();

  if (tokenInformado !== "") {
    payload.api_token = tokenInformado;
  } else if (removerApiToken && !criando) {
    payload.api_token = null;
  }

  return payload;
};
